module.exports = __webpack_public_path__ + "static/img/sysShow1.f2905a1c.png";